import React, { Fragment, useRef, useEffect, useState } from "react";
import{ isAuthenticated, setTheme} from "./screens/helper"
import {Link, useHistory} from "react-router-dom"
import {signout} from "./screens/helper"
import M from "materialize-css"
import $ from "jquery"

import AppTheme from "./colors"
const NavBar = () => {
    // const [ theme, toggleTheme ] = useDarkTheme()   
    const theme = "light"
    const history = useHistory()
    
    const currentTheme =  AppTheme["light"]
    // console.log(currentTheme);
   
    
    
    document.addEventListener('DOMContentLoaded', function() {
        var elems = document.querySelectorAll('.sidenav');
        var instances = M.Sidenav.init(elems, {});
    });

    const [search, setSearch] = useState("")
    const [userDetails, setUserDetails] = useState([])
    const searchModel = useRef(null)
    const {user, token} = isAuthenticated();
    const [isDel, setIsDel] = useState(false);
    useEffect(() => {
        M.Modal.init(searchModel.current)
        
        localStorage.setItem("theme", JSON.stringify("light"));
        if(user){
            if(user.isDeleted === 1){
                setIsDel(true);

            }
        }
    }, [])

    const fetchUsers = (query) => {
        setSearch(query);
        fetch(`${process.env.REACT_APP_BACKEND}/searchusers/${user._id}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                query
            })
        })
        .then(res => res.json())
        .then(results => {
            console.log(results);
            setUserDetails(results.user)
        })
        
    }
    return (
    <>
    {theme ? 
        <>
        <nav>
        <div className="nav-wrapper" style={{backgroundColor: `${currentTheme.navColor}`, boxShadow: `${currentTheme.boxShadow}`}}>
        {isAuthenticated() && (
            <Link to="/" className="brand-logo"  >
            <span style={{color: `${currentTheme.textColor}`}}>SocioRoorkee</span>
            </Link>
        )}
        {!isAuthenticated() && (
            <Link className="brand-logo" to="/login" style={{color: `${currentTheme.textColor}`}}><span style={{color: `${currentTheme.textColor}`}}>SocioRoorkee</span></Link>
        )}
        <a href="#" data-target="mobile-demo" class="sidenav-trigger"><i class="material-icons" style={{
            color: `${currentTheme.textColor}`
        }}>menu</i></a>
        <ul className="right hide-on-med-and-down">
            {!isAuthenticated() && (
                <Fragment>
                <li><Link to="/login" onClick={() => {window.location.reload()}}><span style={{color: `${currentTheme.textColor}`}}>Login</span></Link></li>
                <li><Link to="/signup"><span style={{color: `${currentTheme.textColor}`}}>Signup</span></Link></li>
                </Fragment>
            )
            }
            {isAuthenticated() && !isDel && (
                <Fragment>
                    
                    <li><i data-target="modal1" className="large material-icons modal-trigger" style={{color: `${currentTheme.textColor}`}}>search</i></li> 
                    <li><Link to="/profile"><span style={{color: `${currentTheme.textColor}`}}>Profile</span></Link></li>
                    <li><Link to="/create"><span style={{color: `${currentTheme.textColor}`}}>Create Post</span></Link></li>
                    <li><Link to="/myfollowerspost"><span style={{color: `${currentTheme.textColor}`}}>My Following Post</span></Link></li>
                    {user.role === 1 && (
                        <li><Link to="/admin/updateuser" className="sidenav-close">Update User</Link></li>
                    )}
                    <li><Link onClick={() => {
                        signout(() => {
                            history.push("/login")
                            window.location.reload()
                        })
                    }} to="/login"><span style={{color: `${currentTheme.textColor}`}}>Signout</span></Link></li>
                </Fragment>
            )
            }

            
            </ul>
            </div>
            </nav>
            <div id="modal1" className="modal" ref={searchModel}>
                <div className="modal-content" style={{backgroundColor: `${currentTheme.navColor}`}}>
                <input type="text" placeholder="search users" value={search} onChange={(e) => fetchUsers(e.target.value)} style={{color: `${currentTheme.textColor}`}}/>
                <ul className="collection">
                    {userDetails.map(item => (
                        
                        !item.isDeleted ? (
                            <Link key={item._id} to={item._id !== user._id ? `/profile/${item._id }` : "/profile"} onClick={() => {M.Modal.getInstance(searchModel.current).close()
                                setSearch("")}}><li  className="collection-item">{item.name}</li></Link> 
                        ) : (
                            ""
                        )
                        
                    ))}
                </ul>
                </div>
                <div className="modal-footer" style={{backgroundColor: `${currentTheme.navColor}`, }}>
                <button className="modal-close waves-effect waves-green btn-flat" onClick={() => {setSearch("")}}><span style={{color: `${currentTheme.textColor}`}}>CLOSE</span>   </button>
                </div>
            </div>

        <ul class="sidenav" id="mobile-demo" style={{backgroundColor: `${currentTheme.navColor}`}}>   
        
            {!isAuthenticated() && (
                <Fragment>
                <li><Link to="/login" onClick={() => {window.location.reload()}} className="sidenav-close" style={{color: `${currentTheme.textColor}`}}><span style={{color: `${currentTheme.textColor}`}}>Login</span></Link></li>
                <li><Link to="/signup" className="sidenav-close"><span style={{color: `${currentTheme.textColor}`}}>Signup</span></Link></li>
                </Fragment>
            )
            }
            {isAuthenticated() && !isDel && (
                <Fragment>
                <li><div class="user-view">
                <div class="background">
                    <img src="https://materializecss.com/images/office.jpg"/>
                </div>
                <img class="circle" src={user.pic}/>
                <span class="white-text name">{user.name}</span>
                <span class="white-text email">{user.email}</span>
                </div></li>
                    <li style={{color: 'white'}}><Link data-target="modal1" className="modal-trigger" style={{color: 'white'}}><span style={{color: `${currentTheme.textColor}`}}>Search User</span></Link></li>
                    <li><Link to="/profile" className="sidenav-close"><span style={{color: `${currentTheme.textColor}`}}>Profile</span></Link></li>
                    <li><Link to="/create" className="sidenav-close"><span style={{color: `${currentTheme.textColor}`}}>Create Post</span></Link></li>
                    <li><Link to="/myfollowerspost" className="sidenav-close"><span style={{color: `${currentTheme.textColor}`}}>My Following Post</span></Link></li>
                    {user.role === 1 && (
                        <li><Link to="/admin/updateuser" className="sidenav-close">Update User</Link></li>
                    )}
                    <li><Link onClick={() => {
                        signout(() => {
                            history.push("/login")
                            window.location.reload()
                        })
                    }} to="/login" className="sidenav-close" ><span style={{color: `${currentTheme.textColor}`}}>Signout</span></Link></li>
                    
                    
                </Fragment>
            )
            }
        </ul>
        </>
    : " "}
    </>
        
    )
}

export default NavBar;